import React from "react";
import { T } from "../../../context/LanguageContext";

type RoleToggleProps = {
  options: string[];
  active: string;
  onChange: (value: string) => void;
};

const RoleToggle: React.FC<RoleToggleProps> = ({
  options,
  active,
  onChange,
}) => {
  return (
    <div
      className="inline-flex rounded-full bg-white border border-[#D8D8D8] py-0.5 px-1 space-x-2"
      role="group"
    >
      {options.map((option) => (
        <button
          key={option}
          type="button"
          onClick={() => onChange(option)}
          className={`px-4 py-2 text-sm rounded-full transition-colors duration-200 ${active === option
              ? "bg-[#FBD037] text-[#131327] font-bold shadow-sm"
              : "bg-transparent text-[#212121]/70"
            }`}
        >
          <T>{option}</T>
        </button>
      ))}
    </div>
  );
};

export default RoleToggle;
